var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 17,
    viewBox: "0 0 21 17"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 1h19v15H1z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#5c34cd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 16c0-.003 19.001 0 19.001 0C20.005 16 20 1 20 1 20 1.003.999 1 .999 1 .995 1 1 16 1 16M.999 0H20c.552 0 .999.455.999 1v15c0 .552-.439 1-.999 1H1C.447 17 0 16.545 0 16V1c0-.552.439-1 .999-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 4.5a2 2 0 1 0-4 0 2 2 0 0 0 4 0m-3 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0M20 12.5v-1H1v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.455 8.224-.896-.002 1.978 4a.5.5 0 0 0 .897-.443l-1.978-4a.5.5 0 0 0-.895-.003l-2.008 4.012a.5.5 0 1 0 .894.447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.956 5.224-.895-.002 3.457 6.992a.5.5 0 0 0 .896-.443l-3.457-6.993a.5.5 0 0 0-.895-.002l-3.51 7.012a.5.5 0 1 0 .895.447z"
  })))));
};
export default SvgImage;